//https://github.com/gatsbyjs/gatsby/issues/12399
import 'core-js'
import 'babel-polyfill'
import { polyfill } from 'es6-promise'
import { store } from './src/store'
import { setReferrer } from './src/components/FormHighOrder/features'
global.Promise = require('es6-promise').Promise

const REFERRER_STORAGE_KEY = 'sda_join_referrer'

// Capture a delegate referral token from ?referrer= on first client load and stash it in
// localStorage so it survives reloads / navigating away and back. If it's not in the URL this time,
// rehydrate from localStorage so a referral started earlier in the session still attaches at submit.
export const onClientEntry = () => {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('referrer')
    if (fromUrl) {
      window.localStorage.setItem(REFERRER_STORAGE_KEY, fromUrl)
      store.dispatch(setReferrer(fromUrl))
    } else {
      const stored = window.localStorage.getItem(REFERRER_STORAGE_KEY)
      if (stored) store.dispatch(setReferrer(stored))
    }
  } catch {
    // localStorage/URL unavailable (private mode, SSR edge) — referral is best-effort.
  }
}
polyfill()

export { wrapRootElement } from './gatsby-wrapper'
